module.exports = __webpack_public_path__ + "img/logo-nuhou-2048-transparent-blanc.1053a44e.png";